import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { Container as Color } from 'library/components/color/styles';
import { Header5 } from 'library/styles/text';
import { IconBase } from 'library/styles/icon';
import { ButtonBaseStyles } from 'library/styles/button';
import { TransitionConfig } from '../../../constants/styles-config';

// eslint-disable-next-line import/prefer-default-export
export const SelectedColorsContainer = styled.div`
  padding: 25px 40px 25px 50px;
  background-color: ${Colors.shade07};
  
  ${Color} {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  
  ${Header5} {
    margin-bottom: 17px;
  }
`;

export const Icon = styled(IconBase)`
`;

export const Button = styled.div`
  ${ButtonBaseStyles};
  width: auto;
  padding: 0 18px 0 6px;
  font-size: 15px;
  border: 1px solid ${Colors.violet};
  color: ${Colors.violet};
  transition: background-color ${TransitionConfig}, color ${TransitionConfig};

  &:first-child {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  &:last-child {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
  
  ${({ isActive }) => isActive && `
    color: ${Colors.shade08};
    background-color: ${Colors.violet};
  `}
`;

export const TabsNavigation = styled.div`
  display: flex;
  padding: 24px 50px;
`;
